import {
    GET_LEGAL_POLICIES,
    GET_LEGAL_POLICIES_FULFILLED,
    GET_LEGAL_POLICIES_REJECTED,
    GET_CURRENT_LEGAL_POLICIES,
    GET_CURRENT_LEGAL_POLICIES_FULFILLED,
    GET_CURRENT_LEGAL_POLICIES_REJECTED,
    GET_COMPLIANCE_REQUIREMENTS_V3
} from '../actions/legalActions';

const initialState = {
};

export function legal(state = initialState, action)
{
    switch (action.type)
    {
        case GET_LEGAL_POLICIES:
        {
            return {
                ...state,
                legalPoliciesIsFetching: true
            };
        }
        case GET_LEGAL_POLICIES_FULFILLED:
        {
            return {
                ...state,
                legalPolicy: action.payload,
                lastError: {},
                legalPoliciesIsFetching: false
            };
        }
        case GET_LEGAL_POLICIES_REJECTED:
        {
            return {
                ...state,
                legalPolicy: undefined,
                lastError: action.payload,
                legalPoliciesIsFetching: false
            };
        }
        case GET_CURRENT_LEGAL_POLICIES:
        {
            return {
                ...state,
                currentLegalPoliciesIsFetching: true
            };
        }
        case GET_CURRENT_LEGAL_POLICIES_FULFILLED:
        {
            return {
                ...state,
                currentLegalPolicies: action.payload,
                lastCurrentLegalPoliciesError: {},
                currentLegalPoliciesIsFetching: false
            };
        }

        case GET_CURRENT_LEGAL_POLICIES_REJECTED:
        {
            return {
                ...state,
                currentLegalPolicies: undefined,
                lastCurrentLegalPoliciesError: action.payload,
                currentLegalPoliciesIsFetching: false
            };
        }

        case GET_COMPLIANCE_REQUIREMENTS_V3.pending:
        {
            return {
                ...state,
                complianceRequirementsIsFetching: true
            };
        }
        case GET_COMPLIANCE_REQUIREMENTS_V3.fulfilled:
        {
            return {
                ...state,
                complianceRequirements: action.payload,
                lastComplianceRequirementsError: {},
                complianceRequirementsIsFetching: false
            };
        }

        case GET_COMPLIANCE_REQUIREMENTS_V3.rejected:
        {
            return {
                ...state,
                complianceRequirements: undefined,
                lastComplianceRequirementsError: action.payload,
                complianceRequirementsIsFetching: false
            };
        }

        default: {
            return state;
        }
    }
}
